/**
 * Banner: nova versão do app candidato disponível — um toque para atualizar.
 */
import React from 'react';
import { isStandalonePwa } from '../../pwa/candidatePwa';
import { useCandidatePwaUpdate } from '../../pwa/useCandidatePwaUpdate';

export function CandidatePwaUpdateBanner() {
  const { pwaActive, updateAvailable, applyUpdate, busy } = useCandidatePwaUpdate();

  if (!pwaActive || !updateAvailable) return null;

  const inApp = isStandalonePwa();

  return (
    <div
      role="status"
      style={{
        marginBottom: 16,
        padding: '12px 14px',
        borderRadius: 8,
        border: '1px solid #FCD34D',
        backgroundColor: '#FFFBEB',
        display: 'flex',
        flexDirection: 'column',
        gap: 10,
      }}
    >
      <div style={{ fontSize: 14, color: '#92400E', fontWeight: 600 }}>
        🔄 Atualização disponível
      </div>
      <p style={{ margin: 0, fontSize: 13, color: '#78350F', lineHeight: 1.45 }}>
        {inApp
          ? 'Há uma versão mais recente do aplicativo. Toque abaixo para carregar as melhorias — não é preciso desinstalar.'
          : 'Há uma versão mais recente do site. Toque abaixo para carregar as melhorias.'}
      </p>
      <button
        type="button"
        disabled={busy}
        onClick={applyUpdate}
        style={{
          alignSelf: 'flex-start',
          padding: '8px 14px',
          borderRadius: 6,
          border: 'none',
          backgroundColor: '#D97706',
          color: '#fff',
          fontSize: 14,
          fontWeight: 600,
          cursor: busy ? 'wait' : 'pointer',
          opacity: busy ? 0.85 : 1,
        }}
      >
        {busy ? 'Atualizando…' : 'Atualizar aplicativo'}
      </button>
    </div>
  );
}
